export default __webpack_public_path__ + "graphics/ticket-icon.c05a93ff.png";